/**
 * Fast CAT calculation utilities
 * Based on AKC Fast CAT rules and existing calculation logic from bulk results email
 */

/**
 * Calculate MPH from time
 * Formula: MPH = 204.545 / time
 */
export const calculateMPH = (time: number): number => {
  if (time <= 0) return 0;
  return 204.545 / time;
};

/**
 * Calculate handicap based on height at withers
 * Rules:
 * - 18" or greater: 1.0
 * - 12" up to less than 18": 1.5
 * - below 12": 2.0
 */
export const calculateHandicap = (heightAtWithers: number): number => {
  if (heightAtWithers >= 18) return 1;
  if (heightAtWithers >= 12) return 1.5;
  if (heightAtWithers > 0) return 2;
  return 0; // Default for invalid height
};

/**
 * Calculate Fast CAT points
 * Formula: Points = MPH * Handicap
 */
export const calculatePoints = (time: number, heightAtWithers: number): number => {
  if (time <= 0 || heightAtWithers <= 0) return 0;
  const mph = calculateMPH(time);
  const handicap = calculateHandicap(heightAtWithers);
  return mph * handicap;
};

/**
 * Format number to 2 decimal places
 */
export const formatToTwoDecimals = (value: number): string => {
  return value.toFixed(2);
};
